/*                                     */
/**
 *
 *
 *
 *
 *
 *
 */
import { o_global } from "@gr-common/async/namespaces";
import { asExport } from "@gr-exports/async/core";
import { noop } from "@gr-common/async/function";
/**
 *
 */
export const debugSync = asExport(o_global, "debug", {});
/**
 *
 */
export const logger = asExport(debugSync, "logger", noop);
/**
 *
 */
export const scope = asExport(debugSync, "scope", noop);
/**
 *
 */
export const Level = asExport(debugSync, "Level", noop);
/**
 *
 */
export const status = asExport(debugSync, "status", noop);
